function stripSlash(path) {
  if (path.startsWith('/')) return path.substring(1, path.length);

  return path;
}

function combinePaths(...args) {
  let fullPath = '';

  for (let i = 0; i < args.length; i++) { //eslint-disable-line
    const arg = args[i];

    if (i > 0) fullPath += '/';

    fullPath += stripSlash(arg);
  }

  return fullPath;
}

export default {
  combinePaths
};



// WEBPACK FOOTER //
// ./src/utils/urlUtils.js